import { Injectable, isDevMode, inject } from '@angular/core';
import { BrowserContext } from './browser-context.service';

const BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export type Breakpoint = (typeof BREAKPOINTS)[number];

@Injectable({
  providedIn: 'root',
})
export class ImageScaleBreakpointService {
  private readonly ctx = inject(BrowserContext);

  private breakpointWidths: Record<Breakpoint, string>;

  constructor() {
    if (this.ctx.isBrowser) {
      const computedStyle = this.ctx.window.getComputedStyle(this.ctx.document.documentElement);
      this.breakpointWidths = Object.fromEntries(
        BREAKPOINTS.map(value => [value, computedStyle.getPropertyValue(`--bs-breakpoint-${value}`)])
      ) as Record<Breakpoint, string>;
    } else {
      this.breakpointWidths = {
        xs: '0',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
        xxl: '1400px',
      };
    }
  }

  public generateBootstrapBreakpoints(param: Partial<Record<Breakpoint, string>>) {
    return Object.entries(param)
      .reverse()
      .map(value => {
        const result = `${value[1]}`;
        const valueElement = value[0] as Breakpoint;
        const maxWidth = this.breakpointWidths[valueElement] || '0';
        if (maxWidth !== '0') {
          return `${isDevMode() ? `/*${valueElement}*/` : ''}(min-width: ${maxWidth}) ${result}`;
        }
        return result;
      })
      .join(', ');
  }
}
